import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgNurseMale2 = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.9534 17V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3284 7.625V3.875C16.3284 3.54348 16.1967 3.22554 15.9623 2.99112C15.7278 2.7567 15.4099 2.625 15.0784 2.625H8.82837C8.49685 2.625 8.17891 2.7567 7.94449 2.99112C7.71007 3.22554 7.57837 3.54348 7.57837 3.875V7.625C7.57837 8.78532 8.03931 9.89812 8.85978 10.7186C9.68025 11.5391 10.793 12 11.9534 12C13.1137 12 14.2265 11.5391 15.047 10.7186C15.8674 9.89812 16.3284 8.78532 16.3284 7.625V7.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.57837 7H16.3284"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9534 17C12.7005 17 13.4307 16.7767 14.0501 16.3589C14.6696 15.9411 15.1501 15.3478 15.43 14.655C14.343 14.1414 13.1556 13.875 11.9534 13.875C10.7511 13.875 9.56373 14.1414 8.47668 14.655C8.75663 15.3478 9.23714 15.9411 9.85659 16.3589C10.476 16.7767 11.2062 17 11.9534 17V17Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0784 19.1875C15.0166 19.1875 14.9561 19.2058 14.9048 19.2402C14.8534 19.2745 14.8133 19.3233 14.7897 19.3804C14.766 19.4375 14.7598 19.5003 14.7719 19.561C14.7839 19.6216 14.8137 19.6773 14.8574 19.721C14.9011 19.7647 14.9568 19.7944 15.0174 19.8065C15.078 19.8186 15.1409 19.8124 15.198 19.7887C15.2551 19.7651 15.3039 19.725 15.3382 19.6736C15.3725 19.6222 15.3909 19.5618 15.3909 19.5C15.3909 19.4171 15.3579 19.3376 15.2993 19.279C15.2407 19.2204 15.1612 19.1875 15.0784 19.1875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0467 21.375C19.8916 19.3347 18.9717 17.4282 17.4709 16.0372C15.9702 14.6462 13.9995 13.8733 11.9533 13.8733C9.90711 13.8733 7.93639 14.6462 6.43569 16.0372C4.93498 17.4282 4.01503 19.3347 3.85999 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgNurseMale2.displayName = 'SvgNurseMale2';
export default SvgNurseMale2;
